module.exports = __webpack_public_path__ + "static/media/sports_16.e0770bcf.jpg";